// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tear {
  width: 100%;
  height: 10px;
}

.price {
  width: 30px;
  text-align: center;
}

.qty {
  width: 30px;
  text-align: center;
}

.qty-with-button {
  width: 90px;
  /* text-align: center; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 25px;
  align-self: center;
}

ion-item {
  --min-height: 0px;
}

.folio-row-cover {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px;
  align-items: center;
}

.folio-row {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 16px;
  justify-content: space-between;
  padding-left: 10px;
  height: 35px;
  font-family: "Inter";
}

.gift {
  margin-right: 5px;
  color: var(--orwi-menu-product-price);
  font-size: 18px;
}

.total-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  font-weight: 600;
}

.tip-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  font-weight: 500;
}

.orwi-point-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  font-weight: 500;
}

ion-item {
  --padding-start: 0px;
}

.empty-basket {
  height: 90%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 24px;
  flex-direction: column;
}

.disabled {
  filter: opacity(0.5);
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/folio-rows/folio-rows.component.scss"],"names":[],"mappings":"AAAA;EAEI,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,qCAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ","sourcesContent":[".tear {\n    //background-image: url(/assets/images/folio-tear.svg);\n    width: 100%;\n    height: 10px;\n}\n\n.price {\n    width: 30px;\n    text-align: center;\n}\n\n.qty {\n    width: 30px;\n    text-align: center;\n}\n\n.qty-with-button {\n    width: 90px;\n    /* text-align: center; */\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 25px;\n    align-self: center;\n}\n\nion-item {\n    --min-height: 0px;\n}\n\n.folio-row-cover {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding: 5px;\n    align-items: center;\n}\n\n.folio-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    justify-content: space-between;\n    padding-left: 10px;\n    height: 35px;\n    font-family: 'Inter';\n}\n\n.gift {\n    margin-right: 5px;\n    color: var(--orwi-menu-product-price);\n    font-size: 18px;\n}\n\n.total-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 10px;\n    font-weight: 600;\n}\n\n.tip-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 10px;\n    font-weight: 500;\n}\n\n.orwi-point-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 10px;\n    font-weight: 500;\n}\n\nion-item {\n    --padding-start: 0px;\n}\n\n.empty-basket {\n    height: 90%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    font-size: 24px;\n    flex-direction: column;\n}\n\n.disabled {\n    filter: opacity(0.5);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
